import { BadgeProps, Badge as MuiBadge, styled } from '@mui/material';

const Badge = styled(MuiBadge)(({ theme }) => ({
  padding: theme.spacing(theme.spacingSizes.xs),
  display: 'flex',
  width: theme.spacing(theme.spacingSizes.lg),
  height: theme.spacing(theme.spacingSizes.lg),
  justifyContent: 'center',
  alignItems: 'center',

  '& .MuiBadge-dot': {
    transform: 'none',
    display: 'block',
    position: 'static',
  },
}));

type Props = {
  color: BadgeProps['color'];
};

const StatusBadge: React.FC<Props> = ({ color }) => {
  return <Badge variant="dot" color={color} />;
};

export default StatusBadge;
